module.exports = ".outer {\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  overflow: scroll;\n  z-index: 0;\n}\n\n.outer::-webkit-scrollbar {\n  width: 0px;\n}\n\n.inner {\n  width: 1000%;\n  height: 100%;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/editor/pane/pane.component.css
// module id = ./src/app/components/editor/pane/pane.component.css
// module chunks = main